import type { IconData } from '@stacksjs/iconify-core'

export const dialog: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M695 5q20 0 33 13t13 33v394q0 19-13 32t-33 14H463v162L278 491H46q-19 0-32-14T0 445V51q0-20 14-33T46 5z\"/>",
  "width": 750,
  "height": 800,
  "viewBox": "0 0 750 800"
}

export default dialog
